<script>
  import { fade } from "svelte/transition"
  import { onMount } from "svelte"

  import { _, json } from "svelte-i18n"

  import {
    loading,
    state,
    config,
    difficulty,
    newPlanet,
    helpFlag,
    mode,
    taxi,
    praxi,
    sounds,
    progress,
    planetIndex,
  } from "./js/stores.js"

  import {
    changeMessage,
    getRandInt,
    getUniqueRandIntegers,
    shuffle,
    separateNumberIntoUnits,
    warning,
  } from "./js/functions"

  import MovingStars from "./components/MovingStars.svelte"
  import Bubbles from "./components/Bubbles.svelte"
  import Planet from "./components/Planet.svelte"
  import PlanetsInfoPanel from "./components/PlanetsInfoPanel.svelte"
  import Rocket from "./components/Rocket.svelte"
  import ShootingStar from "./components/ShootingStar.svelte"
  import GameBar from "./components/GameBar.svelte"
  import Astronautis from "./components/Astronautis.svelte"
  import Help from "./components/Help.svelte"
  import ChooseClass from "./components/ChooseClass.svelte"
  import Copyright from "./components/Copyright.svelte"
  import Finale from "./components/Finale.svelte"
  import LangInit from "./components/LangInit.svelte"
  import LangSelect from "./components/LangSelect.svelte"
  import PreloadAssets from "./components/PreloadAssets.svelte"
  import SoundEffects from "./components/SoundEffects.svelte"
  import InsightsTracking from "./components/InsightsTracking.svelte"
  import gsap from "gsap/gsap-core"
  import { animBubbles, animNumbers } from "./js/animations.js"

  // $state.planetIndex = 6
  let finalPlanet = 7
  if (devEnv) finalPlanet = 7
  console.log("mobile", mobile)
  // console.log("localhost", localhost);
  // console.log("devEnv", devEnv);

  let resultsPropaideia = []

  // $: console.log($planetIndex);
  $: $planetIndex && (resultsPropaideia = []) && generateNumbers()

  $: if ($newPlanet && $planetIndex > 1)
    changeMessage($json("planetΙntroMessages")[$planetIndex - 1])

  $: if ($planetIndex === finalPlanet) {
    $state.finished = true
    $sounds.finale.play()
  }

  $: if (!$loading) timeStart()

  $: console.log(resultsPropaideia)

  // $: if ($taxi) console.log("taxi :>> ", $taxi)

  // $: $state.planetIndex && generateNumbers()
  // this does not work, because $state.planetIndex is triggered when performing
  // updates to other properties in the store. The above code is a workaround.
  // See: "Updating property on an object in a store triggers reactivity for the whole store"
  // https://github.com/sveltejs/svelte/issues/4285
  // UPDATE: THAT'S WHY WE USE A DERIVED STORE!

  function getDifficulty() {
    let diff
    let difficultyObj = $difficulty[$praxi][$taxi]

    if ($planetIndex >= 1) {
      for (let i = 0; i < difficultyObj.length; i++) {
        if (difficultyObj[i].stage <= $planetIndex) {
          diff = difficultyObj[i]
        }
      }
    } else {
      diff = difficultyObj[0]
    }

    return diff
  }

  function generateNumbers() {
    let currentDifficulty = getDifficulty()
    $mode = currentDifficulty.mode

    if ($praxi === "prosthesi") {
      // One way to increase dificculty is to increase the range of the numbers
      $state.targetNum = getRandInt(
        currentDifficulty.targetMin,
        currentDifficulty.targetMax
      )
      generateSolutionProsthesi($state.targetNum, currentDifficulty.kratoumeno)

      // $state.numbers = shuffle(getUniqueRandIntegers(5, 1, $state.targetNum - 5, [$state.solution1, $state.solution2]));
      let excludeNumbers =
        $mode === "easy"
          ? [$state.targetNum]
          : [$state.solution1, $state.solution2]
      // let maxNumber = $state.targetNum - 2;
      let maxNumber = currentDifficulty.targetMax

      // Another way to increase dificculty is to increase the available choices
      $state.numbers = getUniqueRandIntegers(
        currentDifficulty.totalChoices,
        $config.minNumber,
        maxNumber,
        excludeNumbers
      )
    } else {
      // Only one mode for multiplication
      $mode = "easy"
      generateSolutionMultiplication(currentDifficulty)
      $state.targetNum = $state.solution1 * $state.solution2

      let offset1 = getUniqueRandIntegers(1, 1, 5, [])[0]
      let offset2 = getUniqueRandIntegers(1, 1, 5, [])[0]
      let trap1 = $state.targetNum - offset1
      let trap2 = $state.targetNum + offset2
      if (trap1 < 1) trap1 = 1
      if (trap2 > 99) trap2 = 99

      $state.numbers = getUniqueRandIntegers(
        currentDifficulty.totalChoices,
        2,
        99,
        [$state.targetNum, trap1, trap2]
      )
      $state.numbers = shuffle($state.numbers)
    }

    $state.numbers = shuffle($state.numbers)
  }

  function generateSolutionProsthesi(targetNum, kratoumeno) {
    // Return 2 numbers that add up to the taget number
    let num1, num2
    let monades1 = 6,
      monades2 = 6 // Just force the while loop to run at least once

    // Should not change this number below 20
    // it may cause infinite loop for target numbers between 10 and 19
    if (targetNum > 10 && !kratoumeno) {
      while (monades1 + monades2 >= 10) {
        // Αν το άθροισμα των μονάδων δίνει κρατούμενο τρέξε ξανά
        // console.log("Inside while loop");
        num1 = getRandInt(1, targetNum - 1)
        // num1 = getRandInt(Math.floor(targetNum / 4), targetNum - Math.floor(targetNum / 6));
        num2 = targetNum - num1

        monades1 = separateNumberIntoUnits(num1).slice(-1)[0]
        monades2 = separateNumberIntoUnits(num2).slice(-1)[0]
      }
    } else {
      // num1 = 12
      // num2 = 25
      // $state.targetNum = num1 + num2

      num1 = getRandInt(1, targetNum - 1)
      num2 = targetNum - num1
    }

    // console.log(num1, num2, targetNum);

    $state.solution1 = num1
    $state.solution2 = num2

    // console.log($state)
    return true
  }

  function generateSolutionMultiplication(currentDifficulty) {
    $state.solution1 = gsap.utils.random(
      currentDifficulty.targetMin1,
      currentDifficulty.targetMax1,
      1
    )
    $state.solution2 = gsap.utils.random(
      currentDifficulty.targetMin2,
      currentDifficulty.targetMax2,
      1
    )

    let string = $state.solution1 + "x" + $state.solution2
    // console.log(string)
    if (resultsPropaideia.includes(string)) {
      generateSolutionMultiplication(currentDifficulty)
      console.log("same", string)
    } else {
      resultsPropaideia = [...resultsPropaideia, string]
    }

    // $state.solution1 = getRandInt(
    //   currentDifficulty.targetMin1,
    //   currentDifficulty.targetMax1
    // )
    // $state.solution2 = getRandInt(
    //   currentDifficulty.targetMin2,
    //   currentDifficulty.targetMax2
    // )

    return true
  }

  function nextBubbles() {
    if (!$state.rocketFull) generateNumbers()
    document.querySelectorAll(".bubble").forEach((bubble) => {
      // bubble.position = "relative"
      bubble.classList.remove("selected")
    })
    if ($state.rocketFull) {
      gsap.timeline().set(".bubble", {
        clearProps: "all",
      })
      changeMessage($_("rocketFull"))
    } else {
      gsap
        .timeline()
        .set(".bubble", {
          clearProps: "all",
        })
        .add(animBubbles("show"))
        .add(animNumbers())
    }
    // }
  }

  function getdifficultyFromURL() {
    const urlParams = new URLSearchParams(window.location.search)
    const URLClass = urlParams.get("class")
    const URLPraxi = urlParams.get("praxi")
    $taxi = URLClass ? URLClass : undefined
    if ($taxi === "a") {
      // Η προπαίδεια ξεκινάει από τη Β' Τ΄άξη!
      $praxi = "prosthesi"
    } else {
      $praxi = URLPraxi ? URLPraxi : "prosthesi"
    }

    if ($taxi) $mode = getDifficulty().mode
  }

  getdifficultyFromURL()
  // console.log($praxi)

  // import { Plugins } from "@capacitor/core"
  // const { SplashScreen } = Plugins

  onMount(() => {
    // Hide the splash (you should do this on app launch)
    // SplashScreen.hide()
    // $helpFlag = true

    // setTimeout(function () {
    //   $helpFlag = true
    // }, 500)

    let introMsg = $mode === "easy" ? $_("introEasy") : $_("intro")
    changeMessage(introMsg)

    warning($state, $taxi) // Warn the user if he tries to leave the page
  })

  var startTime, endTime

  function timeStart() {
    startTime = new Date()
    console.log("time ticking...")
  }

  $: if ($state.finished) $state.seconds = timeEnd()

  function timeEnd() {
    endTime = new Date()
    let timeDiff = endTime - startTime //in ms
    // strip the ms
    timeDiff /= 1000

    // get seconds
    let seconds = Math.round(timeDiff)
    console.log(seconds + " seconds")
    return seconds
  }
</script>

<main>
  <PreloadAssets />
  <LangInit />
  <InsightsTracking />

  {#if $loading}
    <div class="loading" out:fade>
      <h1>{$_("pleaseWait")}</h1>
      <progress value={$progress} />
    </div>
  {/if}

  <PlanetsInfoPanel active="true" />

  <SoundEffects />

  {#if $helpFlag}
    <Help />
  {/if}
  <Planet />
  <div id="top_container">
    <GameBar />
    {#if $state.finished}
      <Finale />
    {:else}
      <Bubbles on:correct={nextBubbles} />
    {/if}
  </div>

  <div id="bottom_container">
    {#if $taxi === undefined}
      <div class="menu-container">
        <ChooseClass />
        <LangSelect />
      </div>
      <Copyright />
    {:else}
      <Rocket />
    {/if}
    <ShootingStar />
  </div>

  {#if $taxi}
    <Astronautis />
  {/if}
  <MovingStars />
</main>

<style>
  main {
    overflow: hidden;
    position: relative;
    width: 100vw;
    height: 100vh;

    display: flex;
    flex-direction: column;
  }

  #top_container {
    /* background: red; */
    flex: 1;
    position: relative;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    /* background: red; */
    z-index: 60;
  }

  #bottom_container {
    /* background: green; */
    flex: 3;
    position: relative;
    display: flex;
    align-items: top;
    justify-content: center;
    z-index: 50;
    padding-top: 100px;
  }

  .loading {
    position: absolute;
    width: 100vw;
    height: 100vh;
    z-index: 1000;
    background: rgb(3, 3, 41);
    color: white;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  progress {
    display: block;
    width: 50%;
    margin-top: 10px;
    height: 40px;
  }

  @media (max-width: 600px) {
    #bottom_container {
      padding-top: 50px;
    }
    .loading h1 {
      font-size: 1.5rem;
    }
  }
</style>
